/**
 * Developer user whitelist
 * Users in this list have access to developer-only features like component labels
 */
export const DEV_USER_IDS = new Set<string>([
  '1257764249',
  '31ozx2p3wpr4nd25gfuquf5pt2ii'
]);

/**
 * Check if a user ID is in the developer whitelist
 * @param userId - The user ID to check (will be trimmed)
 * @returns true if the user is a developer, false otherwise
 */
export const isDevUser = (userId: string | null | undefined): boolean => {
  if (!userId) return false;
  const trimmed = userId.trim();
  if (!trimmed) return false;
  return DEV_USER_IDS.has(trimmed);
};
